import React, { Component } from 'react'
import { MuiTypography, MuiButton, MuiGrid } from '../../../../../ui'
import theme from '../../../../../../assests/theme'
import spinner from "../../../../../ui/icons/spinner.gif";
import { gradePickerUtil } from '../../../../gradePicker';

class UnjoinClassesComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }


  render() {
    const { i18n } = this.props
    return (
      <React.Fragment>
        {/* Display the selected classes*/}
        < MuiGrid container style={{ paddingBottom: "10px" }}>
          <MuiTypography style={theme.typography.h6} gutterBottom>
            {i18n.unjoinClass.unjoinConfirmation}
          </MuiTypography>
        </MuiGrid>

        {/* Buttons  */}
        <MuiGrid container justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>

          <MuiGrid item style={{ marginRight: "10px" }}>
            <MuiButton style={theme.secondaryButtonStyle} onClick={() => { this.props.handleCloseForDialog() }}>
              {i18n.commonTexts.cancel}
            </MuiButton>
          </MuiGrid>

          <MuiGrid item>
            {this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
              <MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={() => { this.props.onClickOfSave() }}>
                {i18n.commonTexts.apply}
              </MuiButton>}
          </MuiGrid>
        </MuiGrid>
      </React.Fragment>
    )
  }
}

export default UnjoinClassesComponent
